import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${space[3]} 0 ${space[5]};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: ${space[4]};
  right: ${space[3]};
  width: 44px;
  height: 32px;
  border-radius: ${layout.borderRadiusFull};
  background: ${colors.white};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
`;

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: ${layout.borderRadiusLg};

  @media (max-width: ${layout.desktopBreakpoint}) {
    height: 170px;
  }
`;

export const ImagePlaceholder = styled.div`
  width: 100%;
  height: 200px;
  background: ${semantic.bg.surfaceStrong};
  border-radius: ${layout.borderRadiusLg};

  @media (max-width: ${layout.desktopBreakpoint}) {
    height: 170px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${space[3]};
  padding: ${space[6]} 0 ${space[5]};
  text-align: center;
`;

export const Heading = styled.h2`
  margin: 0;
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  line-height: 1.2;
`;

export const ValidFor = styled.p`
  margin: 0;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
`;

export const Body = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
  line-height: 1.5;

  & p {
    margin: 0 0 ${space[2]};
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const CtaContainer = styled.div`
  margin-top: ${space[2]};
`;
